import React from "react";
import { useDispatch, useIsMobile } from "hooks";
import { useIsLoggedIn } from "hooks";
import { usePermission } from "hooks";
import { getUnauthorisedMessageElement } from "./PickSlip";
import * as styles from "./PickSlip.module.scss";
import { UnauthorizedPickemsAlerts } from "sections/Betting/Betslip/components/UnauthorizedAlerts";
import { ScrollArea } from "components/ScrollArea";
import { Tab, Tabs, TabsList } from "components/Tabs";
import { ReactComponent as ChevronDown } from "assets/icons/arrow-down-1.svg";
import { setMenu } from "utilities/UI/uiSlice";
import { PageMessage } from "components/PageMessage";
import { ReactComponent as EmptyIcon } from "sections/Pickems/assets/empty.svg";
import { Button } from "components/Button";

const PickSlipNoContest = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useIsLoggedIn();
  const permission = usePermission("submitFreeRoster");
  const isMobile = useIsMobile();

  const unauthorisedMessage = getUnauthorisedMessageElement(
    isLoggedIn,
    permission,
  );

  return (
    <div className={styles.container}>
      <Tabs value="pickems-lobby" className={styles.tabs}>
        <TabsList
          containerClassName={styles.tabListContainer}
          widget={
            <div
              onClick={() => dispatch(setMenu("none"))}
              className={styles.close}
            >
              <ChevronDown />
            </div>
          }
          className={styles.tabList}
        >
          <Tab value="pickems-lobby">Pick'ems</Tab>
        </TabsList>
        <ScrollArea className={styles.scrollArea}>
          <div className={styles.content}>
            <UnauthorizedPickemsAlerts key="unauthorizedPickemsAlerts" />
            {unauthorisedMessage}
            <PageMessage
              className={styles.empty}
              title={"Your Pickslip is Empty"}
              subTitle={
                "Select a contest to submit, or swap your existing picks"
              }
              image={<EmptyIcon />}
            >
              {isMobile && permission === "GRANTED" && (
                <Button size={"md"} onClick={() => dispatch(setMenu("none"))}>
                  View Lobby
                </Button>
              )}
            </PageMessage>
          </div>
        </ScrollArea>
      </Tabs>
    </div>
  );
};

export default PickSlipNoContest;
